import React, { Fragment, useContext } from "react";
import CustomPagination from "../../../components/Pagination/CustomPagination";
import "./BillingTable.css";
import { formDataContext } from "../BillingSummaryReport";
import { Form, FormGroup, Col } from "reactstrap";
import { MessageAlert, ModalComponent } from "../../../components/Components";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ConvertDatetoFormatdateNormal } from "../../../utils/DateUtil";
import { KeyboardArrowDown, KeyboardArrowRight } from "@mui/icons-material";
import BillingDetail from "../../BillingDetail/BillingDetail";
import { useState } from "react";
const BillingTable = (props) => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const {
    page,
    setPage,
    pageSize,
    setPageSize,
    totalRecordCount,
    setIsClickSearch,
    pageCount,
    listHistoryBillingRs,
    setListHistoryBillingRs,
    billingStatusList,
    billingTypeList,
  } = useContext(formDataContext);

  const headersGroup = [
    {
      headerName: "",
      size: "5%",
      headerAlign: "center",
    },
    {
      headerName: t("DeliveryDate"),
      size: "10%",
      headerAlign: "center",
    },
    {
      headerName: t("HeaderTableBillingType"),
      size: "15%",
      headerAlign: "center",
    },
    {
      headerName: t("LotNo"),
      size: "15%",
      headerAlign: "center",
    },
    {
      headerName: t("Status"),
      size: "10%",
      headerAlign: "center",
    },
    {
      headerName: `${t("Income")} (${t("Bath")})`,
      size: "15%",
      headerAlign: "right",
    },
    {
      headerName: `${t("ProcessingFee")}`,
      size: "15%",
      headerAlign: "right",
    },
    {
      headerName: t("EstimatedIncome"),
      size: "15%",
      headerAlign: "right",
    },
  ];

  const [isOpenModalBillingDetail, setIsOpenModalBillingDetail] = useState(false);
  const [billingDetail, setBillingDetail] = useState(null);

  const handleClickBilling = ({ lotno, advno }) => {
    setIsOpenModalBillingDetail(true);
    setBillingDetail({ lotno: lotno, advno: advno });
  };

  const handleExpand = (countIndex) => {
    // const currentIndex = ((page - 1) * pageSize) + countIndex;
    const updatedBilling = listHistoryBillingRs.map((billing, idx) =>
      idx === countIndex ? { ...billing, isExpand: !billing.isExpand } : billing
    );
    setListHistoryBillingRs(updatedBilling);
  };

  return (
    <>
    <div div className="ShearchContainer">
      <div className="ShearchDetailComponent">
        <span className="textHeader">{t("Results")}</span>
      </div>
      <div className="ShearchDetailComponent" style={{ paddingTop: "0px" }}>
        <div style={{ position: "relative" }}>
          <span
            style={{
              fontSize: "medium",
              fontWeight: "bold",
              position: "absolute",
              top: "-25px",
              right: "10px",
            }}
          >
            {`${t("Currency")} (${t("Bath")})`}
          </span>
          <table style={{ width: "100%" }}>
            <thead>
              <tr
                style={{
                  background: "#1976D2",
                  height: "40px",
                  color: "white",
                }}
              >
                {headersGroup?.map((item, index) => (
                  <th
                    key={index}
                    style={{
                      width: item.size,
                      textAlign: item.headerAlign,
                      padding: "0px 20px",
                    }}
                  >
                    {item.headerName}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {listHistoryBillingRs?.map((item, index) => (
                <Fragment>
                  <tr
                    key={index}
                    style={{
                      backgroundColor: index % 2 === 0 ? "#E4EEFF" : "white",
                      height: "40px",
                    }}
                  >
                    {item?.advnoList?.some(
                      (detail) => detail?.advNo != null
                    ) ? (
                      <td style={{ textAlign: "center" }}>
                        {item?.isExpand ? (
                          <KeyboardArrowDown
                            style={{
                              width: "20px",
                              height: "20px",
                              cursor: "pointer",
                            }}
                            onClick={() => handleExpand(index)}
                          />
                        ) : (
                          <KeyboardArrowRight
                            style={{
                              width: "20px",
                              height: "20px",
                              cursor: "pointer",
                            }}
                            onClick={() => handleExpand(index)}
                          />
                        )}
                      </td>
                    ) : (
                      <td></td>
                    )}
                    <td style={{ textAlign: "center" }}>
                      {ConvertDatetoFormatdateNormal(item?.deliveryDate)}
                    </td>
                    <td style={{ textAlign: "center" }}>
                      {billingTypeList?.find(
                        (type) => type?.configValue == item?.billingType
                      )?.configDesc ?? item?.billingType}
                    </td>
                    <td
                      className="hyperLinkBilling"
                      style={{
                        cursor: item?.lotNo == null ? "default" : "pointer",
                      }}
                      onClick={() => {
                        if (item?.lotNo != null) {
                          handleClickBilling({ lotno: item?.lotNo });
                        }
                      }}
                    >
                      {item?.lotNo}
                    </td>
                    <td style={{ textAlign: "center" }}>
                      {item?.billingStatus == null
                        ? t("BillingStatusBillingNotHave")
                        : billingStatusList?.find(
                            (type) =>
                              type?.configValue ==
                              item?.billingStatus
                          )?.configDesc ??
                          item?.billingStatus}
                    </td>
                    <td style={{ textAlign: "right", padding: "0px 20px" }}>
                      {Number(item?.totalIncome).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}
                    </td>
                    <td
                      style={{
                        color: "red",
                        textAlign: "right",
                        padding: "0px 20px",
                      }}
                    >
                      {Number(item?.tradeDiscount).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}
                    </td>
                    <td
                      style={{
                        color: "#03C04A",
                        textAlign: "right",
                        padding: "0px 20px",
                      }}
                    >
                      {Number(item?.estimateIncome).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}
                    </td>
                  </tr>
                  {item?.isExpand && ( //item?.isExpand
                    <tr>
                      <td colSpan={9} style={{padding:"0px"}}>
                        <div
                          style={{
                            backgroundColor:
                              index % 2 === 0 ? "#E4EEFF" : "white",
                            width: "100%",
                            display: "flex",
                            flexDirection: "column",
                            borderRadius: "0px",
                          }}
                        >
                          {item?.advnoList?.map((list, inD) => {
                            return (
                              <div
                                style={{
                                  height: "40px",
                                  display: "flex",
                                }}
                              >
                                <div
                                  style={{ width: headersGroup[0]?.size }}
                                ></div>
                                <div
                                  style={{ width: headersGroup[1]?.size }}
                                ></div>
                                <div
                                  style={{ width: headersGroup[2]?.size }}
                                ></div>
                                <div
                                  style={{
                                    width: headersGroup[3]?.size,
                                    justifyContent: "center",
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <span
                                    className="hyperLinkBilling"
                                    style={{
                                      cursor:
                                        list?.advNo == null
                                          ? "default"
                                          : "pointer",
                                    }}
                                    onClick={() => {
                                      if (list?.advNo != null) {
                                        handleClickBilling({
                                          advno: list?.advNo,
                                        });
                                      }
                                    }}
                                  >
                                    {list?.advNo}
                                  </span>
                                </div>
                                <div
                                  style={{ width: headersGroup[4]?.size }}
                                ></div>
                                <div
                                  style={{
                                    justifyContent: "right",
                                    display: "flex",
                                    alignItems: "center",
                                    padding: "0px 20px",
                                    width: headersGroup[5]?.size,
                                  }}
                                >
                                  {Number(list?.advIncome ?? 0).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}
                                </div>
                                <div
                                  style={{
                                    color: "red",
                                    justifyContent: "right",
                                    display: "flex",
                                    alignItems: "center",
                                    padding: "0px 20px",
                                    width: headersGroup[6]?.size,
                                  }}
                                >
                                  {Number(list?.advTradeDiscount ?? 0).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}
                                </div>
                                <div
                                  style={{
                                    color: "#03C04A",
                                    justifyContent: "right",
                                    display: "flex",
                                    alignItems: "center",
                                    padding: "0px 20px",
                                    width: headersGroup[7]?.size,
                                  }}
                                >
                                  {Number((list?.advIncome ?? 0) - (list?.advTradeDiscount?? 0)).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </td>
                    </tr>
                  )}
                </Fragment>
              ))}
            </tbody>
          </table>
          <CustomPagination
            page={page}
            pageSize={pageSize}
            pageCount={pageCount}
            totalRecordCount={totalRecordCount}
            onPageChange={(newPage) => {
              if (newPage !== page) {
                setPage(newPage);
                setIsClickSearch(true);
              }
            }}
            rowsPerPageOptions={[5, 10, 20, 50]}
            onPageSizeChange={(newSize) => {
              if (newSize !== pageSize) {
                setPage(1);
                setPageSize(newSize);
                setIsClickSearch(true);
              }
            }}
          />
        </div>
      </div>
    </div>
    
    <ModalComponent
        className="custom-modal"
        id="openBillingDetailModal"
        isOpen={isOpenModalBillingDetail}
        onClose={() => setIsOpenModalBillingDetail(false)}
        size={"xl"}
        title={<span className="textHeader">{t("BillingDetail")}</span>}
      >
        {
          <BillingDetail
            billing={billingDetail}
            isModal={true}
            isHideTitle={true}
            setIsOpenModalBillingDetail={setIsOpenModalBillingDetail}
          />
        }
      </ModalComponent>
    </>
  );
};

export default BillingTable;
